import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/HostelCheckInReport/SearchReport",
    method: "get",
    params
  });
}
export function getAdmissionType(params) {
  return request({
    url: "/HostelCheckInReport/GetHomeTown",
    method: "get",
    params
  });
}
export function getColumns(params) {
  return request({
    url: "/HostelCheckInReport/GetReportHeader",
    method: "get",
    params
  });
}
